import { attribution } from './discovery.service';
import { authenticatedFetch } from './auth.service';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://admin.goridesrw.com/api/remote";

const getAuthHeaders = () => ({
  'Content-Type': 'application/json'
});

const handleResponse = async (response) => {
  if (!response.ok) {
    let errorMsg = 'Failed to fetch bookings';
    try {
      const data = await response.json();
      if (data.message) errorMsg = data.message;
    } catch (e) {
      // ignore parse issues and keep fallback message
    }
    throw new Error(errorMsg);
  }

  return response.json();
};

export const renterService = {
  getDashboardStats: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/dashboard/stats`, {
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  getRecentActivity: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/dashboard/activity`, {
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  getMyBookings: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/bookings`, {
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  createBooking: async (payload) => {
    const visit = attribution();
    payload = { ...payload, trafficSource: visit.source, referralCode: visit.referral, visitorSessionId: visit.sessionId };
    const response = await authenticatedFetch(`${BASE_URL}/renter/bookings`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload)
    });
    return handleResponse(response);
  },

  payBookingNow: async (bookingId) => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/bookings/${bookingId}/pay-now`, {
      method: 'POST',
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  cancelBooking: async (bookingId) => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/bookings/${bookingId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  getPayments: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/payments`, {
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  getRefunds: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/refunds`, {
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  getNotifications: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/notifications`, {
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  getSearchRecommendations: async (limit) => {
    const query = typeof limit === 'number' ? `?limit=${limit}` : '';
    const response = await authenticatedFetch(`${BASE_URL}/renter/recommendations${query}`, {
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  getWishlist: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/wishlist`, {
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  getWishlistIds: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/wishlist/ids`, {
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  getReviewEligibility: async (carId) => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/reviews/cars/${carId}/eligibility`, {
      headers: getAuthHeaders()
    });
    return handleResponse(response);
  },

  createReview: async (carId, payload) => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/reviews/cars/${carId}`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      let message = 'Failed to submit review';
      try {
        const data = await response.json();
        message = data.message || message;
      } catch (error) {
        // keep fallback message
      }
      throw new Error(message);
    }
    return true;
  },

  addToWishlist: async (carId) => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/wishlist/${carId}`, {
      method: 'POST',
      headers: getAuthHeaders()
    });
    if (!response.ok) {
      throw new Error('Failed to add car to wishlist');
    }
    return true;
  },

  removeFromWishlist: async (carId) => {
    const response = await authenticatedFetch(`${BASE_URL}/renter/wishlist/${carId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    if (!response.ok) {
      throw new Error('Failed to remove car from wishlist');
    }
    return true;
  }
};
